import React, { useEffect, useState } from "react"
import { toast } from "sonner"
import { DeleteRequest, GetRequest } from "../../../Utils/hooks/ApiHandler"
import { baseURL } from "../../../Utils/constants/constant"
import { EditContactOffcanvas } from "../../../pages/EditContactOffcanvas"
import { ContactDetails } from "../../detailPage/Contacts/ContactDetails"
import imgs from "../../../Utils/assets/img/faces/5.jpg"
import DeleteModal from "../../DeleteModal"
import { Container, Table, Dropdown, Nav } from "react-bootstrap"
import useLocalStorageState from "use-local-storage-state"
import { useNavigate } from "react-router-dom"
import { Pagination } from "../../../pages/Pagination"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons"
import { faEnvelope as farEnvelope } from "@fortawesome/free-regular-svg-icons"
import { CPopover, CButton } from "@coreui/react"
// Lucide React Icons
import { IconPhone } from "@tabler/icons-react"
import nodata from "../../../Utils/assets/img/leads_no_data_found_removebg.png"
import { AuthorizationCard } from "../../../pages/AuthorizationCard";
import { maskContactNumber } from "../../../Utils/helpers/commonhelper";
import { ListSkeleton } from "./contactSkeleton/ListSkeleton"
import { CardSkeleton } from "./contactSkeleton/CardSkeleton"

export const EditContact = ({
  isInitialized,
  allContactData,
  data,
  queryKey,
  // refetch,
  isLoading,
  setOffset,
  offset,
  columns,
  headers,
  currView,
  limit,
  setLimit,
  totalContacts,
  visibleColumns,
  refetch,
  filterData,
  isEditGrant,
  isViewGrant,
  isDeleteGrant,
  setTwillioCallClicked,
  setModuleId,
  showtwilioModal,
  setCallingTo
}) => {
  // delete modal loading state
  const [loading, setLoading] = useState(false)
  let start = offset * limit + 1
  const [customer, setCustomer] = useLocalStorageState("customer")
  const [isOwnerSame, setIsOwnerSame] = useState(false)
  const navigate = useNavigate()
  // edit dropdown state for each card
  const [activeCard, setActiveCard] = useState(null)
  // confirm delete
  const [confirmDeleteId, setConfirmDeleteId] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  // for offcanvas edit
  const [showId, setShowId] = useState(null)
  const [shows, setShows] = useState(false)
  const [showOffcanvas, setShowOffcanvas] = useState(false)
  const [contact_data, setContactData] = useState({})
  const [temData, setTemData] = useState([])
  // Determine the data to display based on filterData
  const dataToDisplay = filterData !== null ? filterData : data
  const hasDataToDisplay = dataToDisplay?.length > 0
  const [contactId, setContactId] = useState("")
  const [openRow, setOpenRow] = useState(null)
  // Calculate total pages
  const pageCount = Math.ceil(totalContacts / limit) || 0

  const isFiltered = filterData !== null

  const effectivePageCount = isFiltered
    ? Math.ceil((dataToDisplay?.length || 0) / limit) || 0
    : pageCount

  const getCountryCode = (company) => {
    try {
      const phoneData = JSON.parse(company.user_phone)
      return phoneData[0]?.country_code ? `+${phoneData[0].country_code}` : ""
    } catch {
      return ""
    }
  }
  // if error while fetching contact
  const [showContactDetailsCanvas, setShowContactDetailsCanvas] =
    useState(false)
  // outside click handler
  useEffect(() => {
    const handler = (event) => {
      const isDropdown = event.target.closest("[data-dropdown]")
      const isOptionsButton = event.target.closest("[data-options-button]")
      if (!isDropdown && !isOptionsButton) {
        setActiveCard(null)
      }
    }
    document.addEventListener("click", handler)
    return () => {
      document.removeEventListener("click", handler)
    }
  }, [])

  // delete contact handler
  const handleDeleteContact = async (contact_id) => {
    setLoading(true)
    try {
      if (!contact_id) return;
      const res = await DeleteRequest(
        `contacts/deleteContact/${contact_id}/${customer?.customer_details?.id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );
      if (res.success === false) {
        setLoading(false)
        toast.error(res.message)
        return
      }
      if (res.status === "fail") {
        setLoading(false)
        toast.warning(res.message)
        return
      }
      refetch()
      setShowDeleteModal(false)
      setLoading(false)
      toast.success(res.message);
      // Predict the new total contacts and page count after deletion
      const newTotalContactsAfterDeletion = totalContacts - 1;
      const newPageCountAfterDeletion = Math.ceil(
        newTotalContactsAfterDeletion / limit
      );
      // If the current offset is now beyond the new last page, adjust it
      if (
        offset >= newPageCountAfterDeletion &&
        newPageCountAfterDeletion > 0
      ) {
        setOffset(newPageCountAfterDeletion - 1);
      } else if (newPageCountAfterDeletion === 0) {
        // If all items are deleted, reset offset to 0
        setOffset(0);
      }
    } catch (error) {
      setLoading(false)
      toast.error("Internal Server Error");
    }
  };
  const visibleColumnLabels = columns
  const getColumnData = (contact, columnLabel, index) => {
    const columnMap = {
      '#': index,
      'Name': contact.contact_full_name,
      'Email': contact.email,
      'Mobile': <span onClick={() => {
        !showtwilioModal && setModuleId(contact.id)
        setCallingTo(`${getCountryCode(contact)} ${maskContactNumber(contact.phone)}`)
        setTwillioCallClicked(true)
      }}>{getCountryCode(contact)} {maskContactNumber(contact.phone)}</span>,
      // 'Mobile': `${getCountryCode(contact)} ${maskContactNumber(contact.phone)}`, // Changed from 'Contact No.' to 'Mobile'
      'Owner': contact.owner_name || "-",
      'Report To': contact.report_to || "-",
      'Visible To': contact.visible_to || "-",
      'Company Name': contact.company_name || "-",
      'Designation': contact.designation || "-",
      'Department': contact.department || "-",
      'Decision Maker': contact.decision_maker || "-",
      'Address': contact.address || "-",
      'City': contact.city_name !== null ? contact.city_name : "-",
      'State': contact.state_name || "-",
      'Country': contact.country_name || "-",
      'Zipcode': contact.zipcode || "-",
      'Lead Source': contact.source_title,
      'Tags': contact.tag ? JSON.parse(contact.tag).join(", ") : "",
      'Notes': contact.note
    };

    return columnMap[columnLabel] || "-";
  };
  // Add this function to get special styling for specific columns
  const getColumnStyle = (columnLabel, contact) => {
    switch (columnLabel) {
      case 'Name':
        return {
          width: '16%',
          cursor: "pointer",
          textTransform: "capitalize",
          color: "inherit",
          fontWeight: 600
        };
      case 'Mobile':
      case 'Email':
        return { color: "#2184ff" };
      case 'Notes':
        return {
          maxWidth: "200px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        };
      default:
        return {};
    }
  };
  const getRandomOwnerColor = () => {
    const colors = [
      { bg: "#E8F4FD", text: "#0B5ED7" },
      { bg: "#E8EAF6", text: "#3F51B5" },
      { bg: "#F3E5F5", text: "#9C27B0" },
      { bg: "#E0F2F1", text: "#009688" },
      { bg: "#E8EAF6", text: "#5C6BC0" },
      { bg: "#FBE9E7", text: "#D84315" }
    ];

    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
  };
  const getColumnContent = (contact, columnLabel, index) => {
    const data = getColumnData(contact, columnLabel, index);

    switch (columnLabel) {
      case "Mobile":
        return (
          <CPopover
            placement="right"
            trigger="hover"
            content={
              <div>
                <div className="row header border-bottom m-0 pb-3">
                  <div className="name d-flex gap-3 rounded align-items-center pr-0">
                    <div className="avatarDivs">
                      <span>{contact.contact_full_name?.substring(0, 2).toUpperCase() || "NA"}</span>
                    </div>
                    <div className="link-primary text-break" style={{ fontSize: '18px', fontWeight: 500, textTransform: "capitalize" }}>
                      {contact.company_name || "-"}
                    </div>
                  </div>
                </div>

                <div className="content">
                  <div className="row w-100 ms-0 mt-3 m-0 border-bottom pb-3">
                    <div className="col-6 read-only-info ml-0 mr-0 mb-2">
                      <div className="label">Company name</div>
                      <div className="title text-truncate">
                        <div className="text-truncate">{contact.company_name || "-"}</div>
                      </div>
                    </div>
                    <div className="col-6 read-only-info p-0 ml-0 mr-0">
                      <div className="label">Industry</div>
                      <div className="title text-truncate">
                        <div className="text-truncate">{contact.department || "-"}</div>
                      </div>
                    </div>
                    <div className="col-6 read-only-info ml-0 mr-0">
                      <div className="label">City</div>
                      <div className="title text-truncate">
                        <div className="text-truncate">{contact.city_name || "-"}</div>
                      </div>
                    </div>
                    <div className="col-6 read-only-info p-0 ml-0 mr-0 mb-2">
                      <div className="label">Country</div>
                      <div className="title text-truncate">
                        <div>{contact.country_name || "-"}</div>
                      </div>
                    </div>
                    <div className="col-6 read-only-info  ml-0 mr-0 mb-2">
                      <div className="label">Owner</div>
                      <div className="title text-truncate">
                        <div className="text-truncate" style={{ textTransform: "capitalize" }}>{contact.owner_name || "-"}</div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 pb-3 w-100 ms-0">
                    <div className="phone-numbers col-md-6">
                      <div className="read-only-info p-0 ml-0 mr-0">
                        <div className="label">Contact No</div>
                        <div className="title text-truncate">
                          <div>
                            <i className="fa-solid fa-phone-volume" style={{ color: "#0250d9", fontSize: 12, marginRight: 6 }}></i>
                            {/* {maskContactNumber(contact.phone) || "-"} */}
                            <span
                              style={{
                                letterSpacing: "0.25px",
                              }}
                            >
                              {getCountryCode(contact)} {maskContactNumber(contact.phone) || "-"}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="emails col-md-6">
                      <div className="read-only-info ml-0 mr-0">
                        <div className="label">Contact Email</div>
                        <div className="title text-truncate">
                          <div>
                            <i className="fa-solid fa-envelope" style={{ color: "#0250d9", fontSize: 14, marginRight: 6 }}></i>
                            {contact.email || "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          >
            <span style={{ cursor: "pointer", letterSpacing: "0.25px" }}>
              <i className="fa-solid fa-phone-volume"></i> {data}
            </span>
          </CPopover>
        );
      case "Email":
        return (
          <p style={{ color: "black" }}>
            <i className="fa-solid fa-envelope" style={{ color: "black" }}></i> {data}
          </p>
        );
      case "Company Name":
        return (
          <span style={{ color: "black" }}>
            {data}
          </span>
        );
      case "Owner":
        const ownerColors = getRandomOwnerColor(contact.owner_name);
        return (
          <div
            style={{
              textTransform: "capitalize",
              backgroundColor: ownerColors.bg,
              color: ownerColors.text,
              borderRadius: "12px",
              padding: "0px 6px",
              textAlign: "center",
            }}
          >
            {contact.owner_name || "-"}
          </div>
        )
      case "Name":
        return (
          <div className="d-flex gap-1 align-items-center" >
            <div style={{
              height: "25px",
              width: "25px",
              display: "inline-block"
            }}>
              <img src={imgs} alt="contact Image"
                style={{
                  height: "100%",
                  width: "100%",
                  borderRadius: "50%"
                }} />
            </div>
            {
              contact.contact_full_name
            }
          </div>
        )
      case "Notes":
        // Add ellipsis for long notes
        return (
          <div
            style={{
              maxWidth: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
            title={data} // Show full text on hover
          >
            {data}
          </div>
        );
      default:
        return data;
    }
  };

  // fetch contact details useEffect
  useEffect(() => {
    if (showId === null) return
      ; (async () => {
        const res = await GetRequest(
          `contacts/getContactDetailsById/${showId}`,
          { headers },
          { customer, setCustomer, rf: headers.Authentication, navigate },
        )
        if (res.err === false || res.status === "fail") {
          toast.error("Error fetching data!")
          return
        }
        const parsedVis = JSON.parse(res?.data[0]?.visible_to)

        // if (
        //   customer?.customer_details?.id === res?.data[0]?.owner_id &&
        //   customer?.customer_details?.user_type === "1"
        // ) {
        //   setIsOwnerSame(true)
        // } else {
        //   setIsOwnerSame(false)
        // }

        if (
          customer?.customer_details?.user_type === "1"
        ) {
          setIsOwnerSame(true)
        } else if (customer?.customer_details?.id === res?.data[0]?.owner_id) {
          setIsOwnerSame(true)
        } else {
          setIsOwnerSame(false)
        }

        setTemData(parsedVis)
        setContactData(res.data[0])
        setShowOffcanvas(true)
      })()
  }, [showId, headers, customer, navigate, setCustomer]) // Added dependencies for useEffect [^1]
  //   handleClose for closing the canvas
  const handleCanvasClose = () => {
    setShowContactDetailsCanvas(false)
  }

  // Handle page change from react-paginate
  const handlePageChange = (selectedItem) => {
    setOffset(selectedItem.selected)
  }

  // Reset offset when filtered data shrinks
  if (isFiltered && offset !== 0 && dataToDisplay?.length === 0) {
    setOffset(0)
  }

  if (!isViewGrant) {
    return <AuthorizationCard />
  }
  return (
    <div className="d-flex flex-column " style={{ marginBottom: "1rem" }}>
      {
        isLoading && !isInitialized ? (
          // Show skeleton while loading
          <>
            {currView === "card" ? (
              <CardSkeleton />
            ) : (
              // Show table skeleton for list view while loading
              <ListSkeleton />
            )}
          </>
        ) : (
          <>
            {currView === "card" ? (
              hasDataToDisplay ? (
                <>
                  <hr />
                  <div className="row position-relative">
                    {dataToDisplay?.map((contact) => {
                      return (
                        <React.Fragment key={contact.id}>
                          <div class="col-xxl-3 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <div
                              class="card custom-card"
                              key={contact.id}
                              style={{
                                boxShadow:
                                  "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                                animation: "cardEntry 1s ease-out forwards",
                                padding: "10px 7px",
                              }}
                            >
                              <div
                                class="card-body contact-action w-100"
                                style={{ padding: "13px 10px" }}
                              >
                                <div class="d-flex align-items-top ">
                                  <div class="d-flex flex-fill gap-3">
                                    <div
                                      class="avatar avatar-xl avatar-rounded"
                                      onClick={(e) => {
                                        setShows("true")
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <img
                                        src={
                                          contact.contact_image !== ""
                                            ? `${baseURL}${contact.contact_image}`
                                            : imgs
                                        }
                                        alt=""
                                      />
                                    </div>
                                    <div style={{ width: "70%" }}>
                                      <h6
                                        class="mb-1 fw-semibold"
                                        onClick={(e) => {
                                          setContactId(contact.id)
                                          setShowContactDetailsCanvas(true)
                                          setShows("true")
                                        }}
                                        style={{
                                          cursor: "pointer",
                                          textTransform: "capitalize",
                                          fontWeight: 300
                                        }}
                                      >
                                        {contact.contact_full_name}
                                      </h6>
                                      <p
                                        class="mb-1 text-muted contact-mail text-truncate"
                                        style={{
                                          width: " 100%",
                                          fontSize: "12px",
                                          minWidth: "100%",
                                        }}
                                      >
                                        {" "}
                                        <FontAwesomeIcon
                                          icon={farEnvelope}
                                        />{" "}
                                        {contact.email}
                                      </p>
                                      {/* <p class="fw-semibold fs-12 mb-0 text-primary">
                                        <IconPhone style={{ width: "14px" }} />{" "}
                                        {contact.phone}
                                      </p> */}
                                      <p class="fw-semibold fs-12 mb-0 text-primary">
                                        <IconPhone style={{ width: "14px" }} />
                                        <span
                                          style={{
                                            fontFamily: "monospace",
                                            letterSpacing: "1px",
                                            whiteSpace: "nowrap",
                                          }}>
                                          {getCountryCode(contact)}{maskContactNumber(contact.phone)}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                  <Dropdown
                                    as="div"
                                    className="dropdownsWithoutToggle"
                                  >
                                    <Dropdown.Toggle
                                      as={Nav.Link}
                                      className="header-link"
                                    >
                                      <FontAwesomeIcon
                                        icon={faEllipsisVertical}
                                        style={{
                                          fontSize: "15px",
                                          width: "20px",
                                          color: "#536485",
                                        }}
                                      />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu
                                      className="defaultDropdown"
                                      align={"end"}
                                      style={{
                                        width: "8rem",
                                        inset: "0px auto auto 0px",
                                        boxShadow:
                                          "rgb(215, 215, 215) 0px 0px 15px",
                                        position: "absolute",
                                        marginTop: "-14px",
                                        minWidth: "3rem",
                                      }}
                                    >
                                      <Dropdown.Item
                                        style={{
                                          fontSize: "12px",
                                          padding: "4px 21px",
                                        }}
                                        href="#"
                                        className="d-flex align-items-center"
                                        onClick={(e) => {
                                          if (isEditGrant) {
                                            e.stopPropagation()
                                            setShowId(contact.id)
                                            setActiveCard(null)
                                            return
                                          }
                                          toast.warning(
                                            "You are not authorized for this action!",
                                          )
                                        }}
                                      >
                                        {" "}
                                        Edit{" "}
                                      </Dropdown.Item>
                                      <Dropdown.Item
                                        style={{
                                          fontSize: "12px",
                                          padding: "4px 21px",
                                        }}
                                        href="#"
                                        onClick={(e) => {
                                          if (isDeleteGrant) {
                                            e.stopPropagation()
                                            setShowDeleteModal(true)
                                            setConfirmDeleteId(contact.id)
                                            setActiveCard(null)
                                            return
                                          }
                                          toast.warning(
                                            "You are not authorized for this action!",
                                          )
                                        }}
                                        className="d-flex align-items-center"
                                      >
                                        {" "}
                                        Delete
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </div>
                              </div>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    })}
                    {dataToDisplay?.length >= 1 && effectivePageCount > 1 && (
                      <div
                        style={{
                          padding: "0.5rem 0",
                          backgroundColor: "white",
                          borderTop: "1px solid #e0e0e0",
                          overflowX: "auto",
                          width: "100%",
                          position: dataToDisplay?.length < 20 && "fixed",
                          bottom: dataToDisplay?.length < 20 && "4rem",
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center gap-2">
                          <div className="pagination-left">
                            <p className="mb-0" style={{ fontSize: "14px" }}>
                              Showing {offset + 1} of{" "}
                              {effectivePageCount !== 0 ? effectivePageCount : effectivePageCount + 1}
                            </p>
                          </div>
                          <div className="pagination-right d-flex gap-2 align-items-center">
                            <select
                              style={{ minWidth: "78px", height: "2.3rem" }}
                              onChange={(e) => {
                                setLimit(Number(e.target.value))
                                setOffset(0)
                              }}
                              id="limit"
                              className="form-control form-select"
                            >
                              <option value={20}>20</option>
                              <option value={100}>100</option>
                              <option value={200}>200</option>
                              <option value={300}>300</option>
                            </select>
                            <div className="d-flex align-items-center gap-3">
                              <Pagination
                                offset={offset}
                                setOffset={setOffset}
                                handlePageChange={handlePageChange}
                                pageCount={effectivePageCount}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                // No data for card view
                <>
                  {/* No Data Found */}
                  <div
                    class="d-flex justify-content-center align-items-center"
                    style={{ position: "absolute", left: "42%" }}
                  >
                    <img
                      src={nodata}
                      alt="nodata_found_img"
                      style={{ width: "17rem", marginTop: "0" }}
                    />
                  </div>
                </>
              )
            ) : (
              // list view
              <Container
                fluid
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  height: "calc(100vh - 10rem)",
                  backgroundColor: "white",
                  padding: 0,
                  animation: "cardEntry 1s ease-out forwards",
                }}
                className="mt-3 p-0"
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <div
                    className="listStyleForContact container-table"
                    style={{
                      flex: dataToDisplay?.length > 8 ? 1 : "auto",
                      overflow: "auto",
                      width: "100%",
                      maxHeight: dataToDisplay?.length > 8 ? "100%" : "auto",
                      scrollbarWidth: "thin",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
                    }}
                  >
                    <Table
                      style={{
                        width: "100%",
                        tableLayout: "auto",
                        backgroundColor: "white",
                        marginBottom: "0px",
                        borderCollapse: "separate",
                        borderSpacing: "0px",
                      }}
                    >
                      <thead style={{ zIndex: 10 }}>
                        <tr style={{ textAlign: "start" }}>
                          {visibleColumnLabels.map((columnLabel) => {
                            return (
                              <React.Fragment key={columnLabel}>
                                {columnLabel !== "Visible To" && (
                                  <th>
                                    {columnLabel}{" "}
                                    <i className="fa-solid fa-sort" />
                                  </th>
                                )}
                              </React.Fragment>
                            )
                          })}
                          <th
                            className="lastactionTd"
                            style={styles.lastdStyle}
                          ></th>
                        </tr>
                      </thead>
                      <tbody className="position-relative" style={{ textAlign: "start" }}>
                        {hasDataToDisplay ? (
                          dataToDisplay?.map((contact, contactIndex) => {
                            return (
                              <React.Fragment key={contact.id}>
                                <tr
                                  style={{
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {visibleColumnLabels.map(
                                    (columnLabel, colIndex) => {
                                      return (
                                        <React.Fragment key={colIndex}>
                                          {columnLabel !== "Visible To" && (
                                            <td
                                              style={getColumnStyle(
                                                columnLabel,
                                                contact,
                                              )}
                                              onClick={
                                                columnLabel === "Name"
                                                  ? () => {
                                                    setContactId(contact.id)
                                                    setShowContactDetailsCanvas(
                                                      true,
                                                    )
                                                  }
                                                  : undefined
                                              }
                                            >
                                              {getColumnContent(
                                                contact,
                                                columnLabel,
                                                start + contactIndex,
                                              )}
                                            </td>
                                          )}
                                        </React.Fragment>
                                      )
                                    },
                                  )}
                                  <td
                                    className="lastactionTd"
                                    style={{
                                      "--pad": "10px",
                                      paddingRight: "var(--pad) !important",
                                      paddingLeft: "var(--pad) !important",
                                      zIndex:
                                        openRow === contact.id ? 11 : "auto",
                                    }}
                                  >
                                    <div className="endTdDiv">
                                      <Dropdown
                                        as="div"
                                        className="dropdownsWithoutToggle"
                                        onToggle={(isOpen) =>
                                          setOpenRow(isOpen ? contact.id : null)
                                        }
                                      >
                                        <Dropdown.Toggle
                                          as={Nav.Link}
                                          className="header-link"
                                        >
                                          <FontAwesomeIcon
                                            icon={faEllipsisVertical}
                                            style={{
                                              fontSize: "15px",
                                              width: "20px",
                                              color: "#536485",
                                            }}
                                          />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu
                                          align={"end"}
                                          style={{
                                            width: "8rem",
                                            inset: "0px auto auto 0px",
                                            boxShadow:
                                              "rgb(215, 215, 215) 0px 0px 15px",
                                            position: "absolute",
                                            marginTop: "-22px",
                                            marginRight: "25px",
                                            minWidth: "3rem",
                                          }}
                                        >
                                          <Dropdown.Item
                                            style={{
                                              fontSize: "12px",
                                              padding: "4px 21px",
                                            }}
                                            className="d-flex align-items-center btn"
                                            onClick={(e) => {
                                              if (isEditGrant) {
                                                e.stopPropagation()
                                                setShowId(contact.id)
                                                return
                                              }
                                              toast.warning(
                                                "You are not authorised for this action!",
                                              )
                                            }}
                                          >
                                            {" "}
                                            Edit{" "}
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            style={{
                                              fontSize: "12px",
                                              padding: "4px 21px",
                                            }}
                                            className="d-flex align-items-center btn"
                                            onClick={(e) => {
                                              if (isDeleteGrant) {
                                                e.stopPropagation()
                                                setShowDeleteModal(true)
                                                setConfirmDeleteId(contact.id)
                                                return
                                              }
                                              toast.warning(
                                                "You are not authorised for this action!",
                                              )
                                            }}
                                          >
                                            {" "}
                                            Delete{" "}
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>
                                </tr>
                                {/* {showContactDetailsCanvas && dataToDisplay && <ContactDeatails show={showContactDetailsCanvas} onCanvasClose={handleCanvasClose} id={contactId} allContacts={data} />} */}
                              </React.Fragment>
                            )
                          })
                        ) : (
                          <td
                            colSpan="14"
                            style={{ textAlign: "center", color: "gray" }}
                          >
                            <div
                              class="d-flex justify-content-center align-items-center"
                              style={{ position: "absolute", left: " 42%" }}
                            >
                              <img
                                src={nodata}
                                alt=""
                                style={{ width: "17rem", marginTop: "0" }}
                              />
                            </div>
                          </td>
                        )}
                        {dataToDisplay?.length > 8 && effectivePageCount > 0 && (
                          <tr
                            className="no-hover-row"
                            style={{
                              backgroundColor: "#ffffff",
                              marginTop: "0px !important",
                              marginBottom: "0px !important",
                            }}
                          >
                            <td colSpan={visibleColumnLabels.length + 2}>
                              <div style={{ padding: 0 }}>
                                <div
                                  className="d-flex justify-content-between align-items-center gap-2 mt-0"
                                  style={{
                                    padding: "0.5rem 0",
                                  }}
                                >
                                  <div className="pagination-left">
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontSize: "14px",
                                        paddingRight: "10rem",
                                      }}
                                    >
                                      Showing {offset + 1} of{" "}
                                      {effectivePageCount !== 0
                                        ? effectivePageCount
                                        : effectivePageCount + 1}
                                    </p>
                                  </div>
                                  <div className="pagination-right d-flex gap-2 align-items-center">
                                    <select
                                      style={{
                                        minWidth: "78px",
                                        height: "2.3rem",
                                      }}
                                      onChange={(e) => {
                                        setLimit(Number(e.target.value))
                                        setOffset(0)
                                      }}
                                      id="limit"
                                      a
                                      className="form-control form-select"
                                    >
                                      <option value={25}>25</option>
                                      <option value={100}>100</option>
                                      <option value={200}>200</option>
                                      <option value={300}>300</option>
                                    </select>
                                    <div className="d-flex align-items-center gap-3">
                                      <Pagination
                                        offset={offset}
                                        setOffset={setOffset}
                                        handlePageChange={handlePageChange}
                                        pageCount={effectivePageCount}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  {dataToDisplay?.length <= 8 && (
                    <div
                      style={{
                        padding: "0.5rem 0",
                        backgroundColor: "white",
                        borderTop: "1px solid #e0e0e0",
                        overflowX: "auto",
                        width: "100%",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center gap-2">
                        <div className="pagination-left">
                          <p className="mb-0" style={{ fontSize: "14px" }}>
                            Showing {offset + 1} of{" "}
                            {pageCount !== 0 ? pageCount : pageCount + 1}
                          </p>
                        </div>
                        <div className="pagination-right d-flex gap-2 align-items-center">
                          <select
                            style={{ minWidth: "78px", height: "2.3rem" }}
                            onChange={(e) => {
                              setLimit(Number(e.target.value))
                              setOffset(0)
                            }}
                            id="limit"
                            className="form-control form-select"
                          >
                            <option value={25}>25</option>
                            <option value={100}>100</option>
                            <option value={200}>200</option>
                            <option value={300}>300</option>
                          </select>
                          <div className="d-flex align-items-center gap-3">
                            <Pagination
                              offset={offset}
                              setOffset={setOffset}
                              handlePageChange={handlePageChange}
                              pageCount={effectivePageCount}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Container>
            )}
          </>
        )
      }
      {showContactDetailsCanvas && contactId && (
        <ContactDetails
          show={showContactDetailsCanvas}
          setShowContactDetailsCanvas={setShowContactDetailsCanvas}
          onCanvasClose={handleCanvasClose}
          id={contactId}
          allContacts={data}
        />
      )}
      {showDeleteModal && (
        <DeleteModal
          onConfirm={() => {
            handleDeleteContact(confirmDeleteId)
            setConfirmDeleteId(null)
          }}
          onClose={() => {
            setConfirmDeleteId(null)
            setShowDeleteModal(false)
          }}
          contactId={confirmDeleteId}
          show={true}
          isLoading={loading}
          message="Are you sure you want to delete this followup?"
        />
      )}
      {/* Move EditContactOffcanvas outside of the main layout structure */}
      {showId !== null && showOffcanvas && (
        <EditContactOffcanvas
          queryKey={queryKey}
          isOwnerSame={isOwnerSame}
          allContacts={allContactData}
          show={true}
          contact_data={contact_data}
          temData={temData}
          refetch={refetch}
          setShow={() => {
            setShowId(null)
            setShowOffcanvas(false)
          }}
        />
      )}
    </div>
  )
}

const styles = {
  lastdStyle: {
    padding: "0 !important",
  },
  lastactiontd: {
    padding: "0px !important",
  },
  lastactionTh: {
    padding: "0px !important",
  },
}